"use client";

import {
  Product,
  ProductEdition,
} from "../../../.storyblok/types/287059/storyblok-components";
import { useMatchingLocaleContext } from "../../helpers/LocaleStringContext";
import { getProductVersionContainsSugar } from "../../helpers/getProductVersionContainsSugar";
import { getStoryblokImageUrl } from "../../helpers/images/getStoryblokImageUrl";
import { CosmosText } from "@cosmos/web-react";
import classnames from "classnames/bind";
import styles from "./LegalDisclaimerBannerChile.module.css";

const cx = classnames.bind(styles);

const LOGO_URL =
  "https://a.storyblok.com/f/287059/2308x1133/ea438184b3/chile-ministerio-de-salud.jpg";

type RedBullVersion =
  Product["redBullVersion"] | ProductEdition["redBullVersion"];

export const LegalDisclaimerBannerChile = ({
  redBullVersion,
}: {
  redBullVersion?: RedBullVersion;
}) => {
  const matchingLocale = useMatchingLocaleContext();

  if (matchingLocale?.legalDisclaimer !== "cl") {
    return null;
  }

  // Show if undefined for FAQ pages
  if (
    redBullVersion !== undefined &&
    !getProductVersionContainsSugar(redBullVersion)
  ) {
    return null;
  }

  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("content")}>
          <img
            className={cx("logo")}
            src={getStoryblokImageUrl(LOGO_URL, { height: 250 })}
            alt="Ministerio de Salud"
          />
          <CosmosText
            tag={"span" /* <- TODO: review this */}
            className={cx("text")}
            size="x-large"
            weight="bold"
          >
            {"Prefiera alimentos con menos sellos de advertencia"}
          </CosmosText>
        </div>
      </div>
    </div>
  );
};
